import { createFileRoute } from "@tanstack/react-router";
import { fetchEdgeGroup, fetchEdgeGroups } from "@/features/edge-groups/queries";
import { edgeGroupsSearchSchema } from "@/features/edge-groups/schemas";
import { EdgeGroupsPage } from "@/features/edge-groups/pages/edge-groups-page";
import { queryKeys } from "@/lib/query-keys";

export const Route = createFileRoute("/_authed/tenants/$slug/agents/edge")({
  validateSearch: (raw: Record<string, unknown>) => edgeGroupsSearchSchema.parse(raw),
  loaderDeps: ({ search }) => ({ group: search.group }),
  loader: ({ context, deps }) => Promise.all([
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.edgeGroups.list(context.tenant.id),
      queryFn: () => fetchEdgeGroups(context.tenant.id),
    }).catch(() => undefined),
    deps.group ? context.queryClient.ensureQueryData({
      queryKey: queryKeys.edgeGroups.group(context.tenant.id, deps.group),
      queryFn: () => fetchEdgeGroup(context.tenant.id, deps.group ?? ""),
    }).catch(() => undefined) : undefined,
  ]),
  component: EdgeGroupsPage,
});
